import axios from '../../http'

class XBSearch {
  // xb搜素商品
  getXBSearchList(data) {
    const url = `/api/xb/goods/list?${data}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 获取品牌数据
  getBrandList() {
    const url = `/api/xb/goods/brand/list`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 获取参数数据
  getParamsList(data) {
    const url = `/api/xb/goods/params?${data}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // xb商品分类数据
  getXBGoodscate() {
    const url = `/api/xb/goods/cate/list`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
}

export default XBSearch;
